export default({ request }) => ({
    materialmaterialMetadataListApi(data = {}) {
        return request({
            url: '/master/materialMetadata/list',
            method: 'post',
            data,
        })
    },
    materialmaterialMetadataDetailApi(data = {}) {
        return request({
            url: '/master/materialMetadata/detail',
            method: 'post',
            data,
        })
    },
    materialmaterialMetadataSaveApi(data = {}) {
        return request({
            url: '/master/materialMetadata/save',
            method: 'post',
            data,
        })
    },
    materialmaterialMetadataDelApi(data = {}) {
        return request({
            url: '/master/materialMetadata/del',
            method: 'post',
            data,
        })
    },
})